import type { ReactNode } from "react";

// Shared visual shell for every screen AuthGate.tsx renders before the user
// is unlocked (checking/locked/resetRequired) - the ambient background and
// card (.auth-bg/.auth-card in styles.css) are built from the app's own
// theme-reactive --body-bg-*/--surface-*/--ink/--muted custom properties,
// so this screen matches whichever theme (light/dark) is currently active.
// No JS theme-reading needed here - the CSS variables themselves cascade
// off the data-theme attribute set on :root by theme.ts.
export function AuthAmbientBackground({ children, variant = "shell" }: { children: ReactNode; variant?: "shell" | "boot" }) {
  return (
    <div className={`auth-bg${variant === "boot" ? " auth-bg--boot" : ""}`}>
      <i className="bi bi-heart-fill auth-deco auth-deco-1" aria-hidden="true" />
      <i className="bi bi-heart-fill auth-deco auth-deco-2" aria-hidden="true" />
      <i className="bi bi-heart-fill auth-deco auth-deco-3" aria-hidden="true" />
      <i className="bi bi-heart-fill auth-deco auth-deco-4" aria-hidden="true" />
      <i className="bi bi-heart-fill auth-deco auth-deco-5" aria-hidden="true" />
      {children}
    </div>
  );
}

export function AuthScreenShell({ title, subtitle, children }: { title: string; subtitle: string; children: ReactNode }) {
  return (
    <AuthAmbientBackground>
      <div className="auth-hero">
        {/* The static enlarging scale lives on this wrapper, never directly
            on the element carrying .heart - .heart's own heartbeat
            animation sets `transform` every keyframe and would silently
            overwrite a static transform applied to it directly. */}
        <span className="auth-hero-icon" aria-hidden="true">
          <span className="heart" />
        </span>
        <h1 className="auth-hero-title">{title}</h1>
        <p className="auth-hero-subtitle">{subtitle}</p>
      </div>
      {children}
    </AuthAmbientBackground>
  );
}
